/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy in Depth`)
};

const es_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy en profundidad`)
};

const de_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy im Detail`)
};

const nl_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy in detail`)
};

const fr_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy en détail`)
};

const it_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy in dettaglio`)
};

const pt_br2_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy em detalhes`)
};

const pt_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy em detalhe`)
};

const ja_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー詳細`)
};

const zh_about_section_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy 深度解析`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_f1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_f1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_f1", locale)
	if (locale === "en") return en_about_section_f1(inputs)
	if (locale === "es") return es_about_section_f1(inputs)
	if (locale === "de") return de_about_section_f1(inputs)
	if (locale === "nl") return nl_about_section_f1(inputs)
	if (locale === "fr") return fr_about_section_f1(inputs)
	if (locale === "it") return it_about_section_f1(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_f1(inputs)
	if (locale === "pt") return pt_about_section_f1(inputs)
	if (locale === "ja") return ja_about_section_f1(inputs)
	return zh_about_section_f1(inputs)
};